function formatDate(dateStr) {
  const d = new Date(dateStr);
  const now = new Date();
  const isToday = d.toDateString() === now.toDateString();
  if (isToday) {
    return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  }
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) {
    return "Yesterday";
  }
  return d.toLocaleDateString([], { month: "short", day: "numeric" });
}

function getInitials(name) {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

const AVATAR_COLORS = [
  "#3b82f6",
  "#8b5cf6",
  "#ec4899",
  "#f59e0b",
  "#10b981",
  "#ef4444",
  "#06b6d4",
  "#6366f1",
];

function getAvatarColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function EmailListItem({ email, isSelected, onClick }) {
  const isUnread = !email.read;
  const initials = getInitials(email.from.name);
  const avatarColor = getAvatarColor(email.from.name);

  return (
    <button
      onClick={() => onClick(email)}
      className={`w-full text-left px-4 py-3 border-b border-slate-100 transition-colors relative cursor-pointer ${
        isSelected
          ? "bg-blue-50"
          : "hover:bg-gray-50"
      }`}
    >
      {/* Unread indicator */}
      {isUnread && (
        <div
          className="absolute top-1/2 left-1.5 -translate-y-1/2 h-2 w-2 rounded-full"
          style={{ backgroundColor: "#3b82f6" }}
        />
      )}

      <div className={`flex gap-3 ${isUnread ? "pl-2" : ""}`}>
        {/* Avatar */}
        <div
          className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
          style={{ backgroundColor: avatarColor }}
        >
          <span className="text-xs font-semibold text-white">{initials}</span>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-0.5">
            <span
              className={`text-sm truncate ${
                isUnread
                  ? "font-semibold text-slate-900"
                  : "font-normal text-slate-600"
              }`}
            >
              {email.from.name}
            </span>
            <span className="text-xs text-slate-400 ml-2 flex-shrink-0">
              {formatDate(email.date)}
            </span>
          </div>
          <p
            className={`text-sm truncate ${
              isUnread
                ? "font-medium text-slate-800"
                : "text-slate-600"
            }`}
          >
            {email.subject}
          </p>
          <p className="text-xs text-slate-400 truncate mt-0.5">
            {email.preview}
          </p>
        </div>
      </div>
    </button>
  );
}
